<template>
  <tw-dropdown :disabled="LoadingMarkAsResolved || LoadingDeleting || LoadingMarkAsInProgress || LoadingDiscarding" :size="size" :block="block" variant="primary">
    <template #button>
      <tw-loading-spinner-mini v-if="LoadingMarkAsResolved">
        Marking as resolved...
      </tw-loading-spinner-mini>
      <tw-loading-spinner-mini v-else-if="LoadingDeleting">
        Deleting...
      </tw-loading-spinner-mini>
      <tw-loading-spinner-mini v-else-if="LoadingDiscarding">
        Discarding...
      </tw-loading-spinner-mini>
      <tw-loading-spinner-mini v-else-if="LoadingMarkAsInProgress">
        Marking in Progress...
      </tw-loading-spinner-mini>
      <span v-else>Mark as...</span>
    </template>
    <tw-dropdown-item @click="markAsInProgress">
      In Progress
    </tw-dropdown-item>
    <tw-dropdown-item @click="markAsResolved">
      Resolved
    </tw-dropdown-item>
    <tw-dropdown-item @click="discard">
      Discarded
    </tw-dropdown-item>
    <tw-dropdown-item variant="danger" @click="deleteSupportRequest">
      <icon icon="times" />  Delete
    </tw-dropdown-item>
  </tw-dropdown>
</template>

<script>
import axios from 'axios'
import TwDropdown from '@/components/generic/dropdown/tw-dropdown.vue'
import TwDropdownItem from '@/components/generic/dropdown/tw-dropdown-item.vue'
import TwLoadingSpinnerMini from '@/components/generic/tw-loading-spinner-mini.vue'
import { useSupportRequestsStore } from '@/stores/supportRequests.js'

export default {
  name: 'SupportRequestActionsDropdown',
  components: { TwLoadingSpinnerMini, TwDropdownItem, TwDropdown },
  props: {
    supportRequest: {
      type: Object,
      required: true
    },
    size: {
      type: String,
      default: null
    },
    block: {
      type: Boolean,
      default: false
    }
  },
  data () {
    return {
      LoadingMarkAsResolved: false,
      LoadingDiscarding: false,
      LoadingMarkAsInProgress: false,
      LoadingDeleting: false
    }
  },
  methods: {
    async markAsResolved () {
      if (confirm('Mark issue as resolved?')) {
        this.LoadingMarkAsResolved = true
        const { data } = await axios.post('/api/v1/support-requests/' + this.supportRequest.id + '/mark-as-resolved')
        useSupportRequestsStore().itemPatchState(data)
        this.LoadingMarkAsResolved = false
      }
    },
    async markAsInProgress () {
      if (confirm('Mark as in progress?')) {
        this.LoadingMarkAsInProgress = true
        const { data } = await axios.post('/api/v1/support-requests/' + this.supportRequest.id + '/mark-as-in-progress')
        useSupportRequestsStore().itemPatchState(data)
        this.LoadingMarkAsInProgress = false
      }
    },
    async deleteSupportRequest () {
      if (confirm('Delete issue?')) {
        this.LoadingDeleting = true
        await axios.delete('/api/v1/support-requests/' + this.supportRequest.id)
        useSupportRequestsStore().itemDelete(this.supportRequest.id)
        this.LoadingDeleting = false
        await this.$router.push({ name: 'support-requests-index-page' })
      }
    },
    async discard () {
      if (confirm('Discard issue?')) {
        this.LoadingDiscarding = true
        const { data } = await axios.post('/api/v1/support-requests/' + this.supportRequest.id + '/discard')
        useSupportRequestsStore().itemPatchState(data)
        this.LoadingDiscarding = false
      }
    }
  }
}
</script>

<style scoped>

</style>
